import React from "react";
import ComingSoonPanel from "../components/ComingSoonPanel";

const AdsAnalysisPage: React.FC = () => {
    return (
        <ComingSoonPanel
            title="広告分析"
            description="RPP・CPA広告などメニュー別のROAS/利益を表示する想定です。"
        />
    );
};

export default AdsAnalysisPage;
